import { Country } from '@dreryk/address-common-api';

import { Bean, commonTranslationKeys, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import { Select, StyledMaxWidth } from '@dreryk/react-components';

import { CountriesSelectList, getCountryDisplayValue } from '~libs.desktop.shared.fields';

import { medicalLeaveTranslationKeys } from '../../../../../../translations';

const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
};

type PassportCountryFieldProps = FieldControllerProps<'passportCountry', Country | null>;

export const PassportCountryField = (props: PassportCountryFieldProps): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<Country>
            testId={'passportCountry'}
            triggerLabelExtractor={getCountryDisplayValue}
            controller={props.register('passportCountry', VALIDATION_RULES)}
            defaultValue={null}
            label={medicalLeaveTranslationKeys.personalData.passportCountry.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
            searchInputEnabled
         >
            <CountriesSelectList />
         </Select>
      </StyledMaxWidth>
   );
};
